var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-direccion"},[_c('select',{ref:"select",attrs:{"id":_vm.id}},[_c('option',{attrs:{"value":""}}),_vm._l((_vm.options),function(item){return _c('option',{key:item.id,domProps:{"value":String(item.id)}},[_vm._v(" "+_vm._s(item.nombre + ' - ' + item.direccion)+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }